<template>
    <b-modal v-model="modalShow" ref="modal-reverse-pay-installment" title="Estornar Parcela">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group bmd-form-group"
                         v-bind:class="{'is-filled': true}">
                        <label for="pay_at" class="bmd-label-floating">Data</label>
                        <date-picker v-model="form.reversal_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitReversalPayInstallment" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>
<script>
    import Vue from 'vue';
    import ValidationService from '@/services/validations.service';

    export default {
        computed: {
        },
        data() {
            return {
                form: {
                    id: 0,
                    installment_id: 0,
                    reversal_at: new Date()
                },
                modalShow: true,
                validation: {
                    reversal_at: ''
                }
            };
        },
        mounted() {
            var self = this;

            self.form.id = self.$route.params.id;
            self.form.installment_id = self.$route.params.installment;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        },
        methods: {
            goBack() {
                var self = this;
                self.$router.push({'name': 'proposals.show', params: {'id': self.$route.params.id}});
            },
            onSubmitReversalPayInstallment(_ev) {
                _ev.preventDefault();
                var self = this;
                
                if (self.form.reversal_at == null) {
                    self.$notify.error("Favor fornecer a data do estorno!");
                } else {
                    self.$root.$emit("onLoading");
                    const response = self.$store.dispatch('proposals/reverse_pay_installment', self.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Pagamento efetuado com sucesso!");
                        self.goBack();
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        self.$notify.error("Não foi possivel efetuar o estorno da parcela, tente novamente!");
                    });
                }
            }
        }
    };
</script>